import { defineMessages } from 'react-intl';

export default defineMessages({
  pendingfulfillment: {
    id: 'deliverystatus.pendingfulfillment.title',
    defaultMessage: 'Pending Fulfillment'
  },
  fulfilled: {
    id: 'deliverystatus.fulfilled.title',
    defaultMessage: 'Fulfilled'
  },
});
